var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBulgaria(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5 3",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 3,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    y: 1,
    fill: "#00966E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 1,
    y: 2,
    fill: "#D62612"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulgaria);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1IDMiPgo8cmVjdCB3aWR0aD0iNSIgaGVpZ2h0PSIzIiBmaWxsPSIjZmZmIi8+CjxyZWN0IHdpZHRoPSI1IiBoZWlnaHQ9IjIiIHk9IjEiIGZpbGw9IiMwMDk2NkUiLz4KPHJlY3Qgd2lkdGg9IjUiIGhlaWdodD0iMSIgeT0iMiIgZmlsbD0iI0Q2MjYxMiIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };